import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NbPasswordAuthStrategy, NbAuthModule, NbAuthJWTToken, NbAuthJWTInterceptor, NB_AUTH_INTERCEPTOR_HEADER, NB_AUTH_TOKEN_INTERCEPTOR_FILTER, nbNoOpInterceptorFilter } from '@nebular/auth';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { filterPassThruRequest } from './core/utils/filterPassThruRequest';
import { NbSecurityModule, NbRoleProvider } from '@nebular/security';
import { UserService } from './core/services/user.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ConfirmationService } from 'primeng/api';
import {MessageService} from 'primeng/api';
import { DatePipe } from '@angular/common';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    // EditorModule,
    AppRoutingModule,
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'email',
          baseEndpoint: environment.baseApi,
          login: {
            endpoint: environment.endPoints.users.login
          },
          logout: {
            endpoint: environment.endPoints.users.logout,
            method: 'POST'
          },
          token: {
            class: NbAuthJWTToken,
            key: 'token'
          }
        }),
      ],
      forms: {},
    }),
    NoopAnimationsModule,
    HttpClientModule,
    NbSecurityModule.forRoot({
      accessControl: {
        guest: {
          view: [ '/' ]
        },
        USUARIO: {
          parent: 'guest',
          view: [
            'dashboarUser'
          ]
        },
        ADMINISTRADOR: {
          parent: 'guest',
          view: [
            'menu-privado',
            'dashboarAdmin',
            'admin-users',
            'admin-plazas',
            'admin-vehiculos',
            'admin-regulacion',
            'admin-sesionesEstacionamiento',
            'admin-historicoSesiones',
            'admin-sugerencias',
            'admin-contactoSoporte',
            'admin-alertas',
            'admin-zonaVigilancia',
            'admin-noticias'],
        },
        SUPERVISOR: {
          parent: 'guest',
          view: [
            'menu-privado',
            'dashboarAdmin',
            'admin-users',
            'admin-plazas',
            'admin-vehiculos',
            'admin-regulacion',
            'admin-sugerencias',
            'admin-contactoSoporte',
            'admin-alertas',
            'admin-zonaVigilancia',
            'admin-noticias'
          ]
        },
        CONTROLADOR: {
          parent: 'guest',
          view: [
            'menu-privado',
            'dashboarAdmin',
            'admin-regulacion',
            'admin-alertas'
          ]
        },
        ANALISTA: {
          parent: 'guest',
          view: [
            'menu-privado',
            'dashboarAdmin',
            'admin-sesionesEstacionamiento',
            'admin-historicoSesiones'
          ]
        }
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    })
  ],
  providers: [
    ConfirmationService,
    MessageService,
    { provide: HTTP_INTERCEPTORS, useClass: NbAuthJWTInterceptor, multi: true},
    { provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER, useValue: filterPassThruRequest },
    { provide: NbRoleProvider, useClass: UserService },
    DatePipe

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
